/* import __COLOCATED_TEMPLATE__ from './categories-and-top-topics.hbs'; */
import Component from "@ember/component";
import { classNames } from "@ember-decorators/component";

@classNames("categories-and-top")
export default class CategoriesAndTopTopics extends Component {}
